import { useEffect, useRef, useState } from 'react';

const useOnScreen = () => {
    const [isIntersecting, setIntersecting] = useState(false);

    const ref = useRef();

    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) =>
            setIntersecting(entry.isIntersecting)
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            observer.disconnect();
        };
    }, [ref]);

    return { ref, isIntersecting };
};

export default useOnScreen;
